import src from "./glamour.svg";
export default { src: src, aspect: 4.0000, width: 168, height: 42 };